import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE} from "types/enums";
import Icon from "@ant-design/icons";
import Icons from "assets/icons";
import React from "react";

const {RADIO, INPUT, TEXT_AREA, RADIO_BUTTON, NUMBER} = FIELD_TYPE;

const css = {xs: 24, sm: 24, md: 24, lg: 24, xl: 24};
const wrapperCol = {xs: 16, md: 16, lg: 16};
const labelCol = {xs: 8, md: 8, lg: 8};

export const FieldsPulpil1: any[] = [
  {
    name: ["rightJsonValue", "PUPIL", "Hình dạng"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
    label: "Hình dạng",
    radioButtons: [
      {
        label: "Tròn",
        value: "Tròn",
      },
      {
        label: "Lệch giữa",
        value: "Lệch giữa",
      },
      {
        label: "Không đều",
        value: "Không đều",
      },
      {
        label: "Oval",
        value: "Oval",
      },
      {
        label: "Nhiều đồng tử",
        value: "Nhiều đồng tử",
      },
    ],
  },
  {
    label: "Kích cỡ đồng tử",
    type: NUMBER,
    max: 10,
    name: ["rightJsonValue", "PUPIL", "Kích cỡ đồng tử"],
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
    suffix: "mm",
  },
  {
    name: ["rightJsonValue", "PUPIL", "Phản xạ ánh sáng trực tiếp"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: {xs: 8, md: 8, lg: 8},
    wrapperCol: {xs: 16, md: 16, lg: 16},
    label: "Phản xạ ánh sáng trực tiếp",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Chậm",
        value: "Chậm",
        span: 8,
      },
      {
        label: "Mất",
        value: "Mất",
        span: 8,
      },
    ],
    value: "Bình thường",
  },
  {
    name: ["rightJsonValue", "PUPIL", "Phản xạ ánh sáng đồng thuận"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: {xs: 8, md: 8, lg: 8},
    wrapperCol: {xs: 16, md: 16, lg: 16},
    label: "Phản xạ ánh sáng đồng thuận",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Chậm",
        value: "Chậm",
        span: 8,
      },
      {
        label: "Mất",
        value: "Mất",
        span: 8,
      },
    ],
    value: "Bình thường",
  },
  {
    label: "Tổn thương phản xạ đồng tử hướng tâm (RAPD)",
    type: RADIO_BUTTON,
    css: css,
    labelCol: {xs: 12, md: 12, lg: 12},
    wrapperCol: {xs: 12, md: 12, lg: 12},
    radioButtons: [
      {value: false, label: "Không"},
      {value: true, label: "Có"},
    ],
    value: false,
    name: [
      "rightJsonValue",
      "Pulpil",
      "Tổn thương phản xạ đồng tử hướng tâm (RAPD)",
    ],
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["rightJsonValue", "PUPIL", "Ghi chú"],
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "PUPIL", "show"],
    hide: true,
  },
];

export const FieldsPulpil2: any[] = [
  {
    name: ["leftJsonValue", "PUPIL", "Hình dạng"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
    label: "Hình dạng",
    radioButtons: [
      {
        label: "Tròn",
        value: "Tròn",
      },
      {
        label: "Lệch giữa",
        value: "Lệch giữa",
      },
      {
        label: "Không đều",
        value: "Không đều",
      },
      {
        label: "Oval",
        value: "Oval",
      },
      {
        label: "Nhiều đồng tử",
        value: "Nhiều đồng tử",
      },
    ],
  },
  {
    label: "Kích cỡ đồng tử",
    type: NUMBER,
    max: 10,
    name: ["leftJsonValue", "PUPIL", "Kích cỡ đồng tử"],
    css: css,
    addonAfter: "mm",
  },
  {
    name: ["leftJsonValue", "PUPIL", "Phản xạ ánh sáng trực tiếp"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: {xs: 8, md: 8, lg: 8},
    wrapperCol: {xs: 16, md: 16, lg: 16},
    label: "Phản xạ ánh sáng trực tiếp",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Chậm",
        value: "Chậm",
        span: 8,
      },
      {
        label: "Mất",
        value: "Mất",
        span: 8,
      },
    ],
    value: "Bình thường",
  },
  {
    name: ["leftJsonValue", "PUPIL", "Phản xạ ánh sáng đồng thuận"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: {xs: 8, md: 8, lg: 8},
    wrapperCol: {xs: 16, md: 16, lg: 16},
    label: "Phản xạ ánh sáng đồng thuận",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Chậm",
        value: "Chậm",
        span: 8,
      },
      {
        label: "Mất",
        value: "Mất",
        span: 8,
      },
    ],
    value: "Bình thường",
  },
  {
    label: "Tổn thương phản xạ đồng tử hướng tâm (RAPD)",
    type: RADIO_BUTTON,
    css: css,
    labelCol: {xs: 12, md: 12, lg: 12},
    wrapperCol: {xs: 12, md: 12, lg: 12},
    name: [
      "leftJsonValue",
      "PUPIL",
      "Tổn thương phản xạ đồng tử hướng tâm (RAPD)",
    ],
    radioButtons: [
      {value: false, label: "Không"},
      {value: true, label: "Có"},
    ],
    value: false,
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["leftJsonValue", "PUPIL", "Ghi chú"],
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "PUPIL", "show"],
    hide: true,
  },
];
